import { render, staticRenderFns } from "./rightContent.vue?vue&type=template&id=970b1774&scoped=true&"
import script from "./rightContent.vue?vue&type=script&lang=js&"
export * from "./rightContent.vue?vue&type=script&lang=js&"
import style0 from "./rightContent.vue?vue&type=style&index=0&id=970b1774&prod&lang=scss&scoped=true&"
import style1 from "./rightContent.vue?vue&type=style&index=1&id=970b1774&prod&lang=scss&scoped=true&"
import style2 from "./rightContent.vue?vue&type=style&index=2&id=970b1774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970b1774",
  null
  
)

export default component.exports